import { hot } from 'react-hot-loader/root';
import Component from './organisationSettings-redux';

export default hot(Component);
